import React from "react";
import PropTypes from "prop-types";
import useTranslations from "../../../hoc/useTranslations";
import Button from "../Button";

const Floating = ({ toggleModal }) => {
	const { getDemoButton } = useTranslations();

	return (
		<aside className="floating__button">
			<Button onClick={toggleModal}>{getDemoButton}</Button>
		</aside>
	);
};

Floating.propTypes = {
	toggleModal: PropTypes.func.isRequired,
};

export default Floating;
